import { dashboardSelectBusiness } from '@/modules/dashboard/dashboardActions';
import type { Business } from '@/modules/dashboard/dashboardTypes';
import { useDispatch } from 'react-redux';

export const useSelectBusinessMutation = () => {
	const dispatch = useDispatch();

	const mutate = (business: Business | null) => {
		dispatch(dashboardSelectBusiness(business));
	};

	return { mutate };
};
